import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios';
import Cookies from "js-cookie";
import { Constants } from "./constants.js";

import "bootstrap";
import "jquery-ui";
import "jquery-ui/themes/base/all.css";
import "jquery-confirm";
import "jquery-confirm/css/jquery-confirm.css";

import "./assets/js/date.format";
import "./filter";
import "./assets/js/custom";
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload);

Vue.config.productionTip = false;
Vue.config.devtools = true;

// import CKEditor from "ckeditor4-vue";
// Vue.use(CKEditor);

import VueCurrencyFilter from "vue-currency-filter";
Vue.use(VueCurrencyFilter, {
  symbol: "",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: true,
});

import Embed from "v-video-embed";
Vue.use(Embed);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import ModalService from "vue-modal-service";
Vue.use(ModalService);

import Notifications from 'vue-notification'
Vue.use(Notifications)

Vue.prototype.$eventHub = new Vue(); // Global event bus

// Log environment variables on startup
console.log('🚀 Safari Trek Beach Admin - Starting Application');
console.log('📄 Environment Variables (from Docker):');
console.log('='.repeat(60)); 
console.log(`NODE_ENV=${process.env.NODE_ENV}`);
console.log(`VUE_APP_API_URL=${process.env.VUE_APP_API_URL}`);
console.log(`VUE_APP_API_URL_GALLERY=${process.env.VUE_APP_API_URL_GALLERY}`);
console.log(`VUE_APP_API_URL_ACCOMMODATION=${process.env.VUE_APP_API_URL_ACCOMMODATION}`);
console.log(`VUE_APP_EMAIL_URL=${process.env.VUE_APP_EMAIL_URL}`);
console.log(`VUE_APP_OPERATOR_URL=${process.env.VUE_APP_OPERATOR_URL}`);
console.log(`VUE_APP_BASE_URL=${process.env.VUE_APP_BASE_URL}`);
console.log(`VUE_APP_PUBLIC_PATH=${process.env.VUE_APP_PUBLIC_PATH}`);
console.log(`VUE_APP_PACKAGE_URL=${process.env.VUE_APP_PACKAGE_URL}`);
console.log(`VUE_APP_PREVIEW_PACKAGE_URL=${process.env.VUE_APP_PREVIEW_PACKAGE_URL}`);
console.log(`VUE_APP_BLOG_URL=${process.env.VUE_APP_BLOG_URL}`);
console.log(`VUE_APP_DESTINATION_URL=${process.env.VUE_APP_DESTINATION_URL}`);
console.log(`VUE_APP_LANDING_URL=${process.env.VUE_APP_LANDING_URL}`);
console.log(`VUE_APP_THINGS_URL=${process.env.VUE_APP_THINGS_URL}`);
console.log(`VUE_APP_PLACES_URL=${process.env.VUE_APP_PLACES_URL}`);
console.log(`VUE_APP_IPREGISTRY_SECRET_KEY=${process.env.VUE_APP_IPREGISTRY_SECRET_KEY}`);
console.log(`VUE_APP_IPREGISTRY_URL=${process.env.VUE_APP_IPREGISTRY_URL}`);
console.log(`VUE_APP_TOUR_BANNER_YOUTUBE_URL=${process.env.VUE_APP_TOUR_BANNER_YOUTUBE_URL}`);
console.log('='.repeat(60));

axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {

      originalRequest._retry = true;

      Cookies.remove(Constants.LOGIN_USER);
      Cookies.remove(Constants.API_TOKEN);
      localStorage.clear();
      return router.push('/')
    }
  }
})


new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
